import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';
import { TableModule }  from '../../table/table.module';

import { TransactionCenterInspectionsComponent } from './transaction-center.inspections.component';
import { TransactionCenterInspectionsService }   from './transaction-center.inspections.service';

@NgModule({
  declarations: [
    TransactionCenterInspectionsComponent
  ],
  entryComponents: [
    TransactionCenterInspectionsComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    TransactionCenterInspectionsService
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class TransactionCenterInspectionsModule {}
